export const RECEIVE_REPORTS_INITIAL_DATA = 'RECEIVE_REPORTS_INITIAL_DATA';
export const FETCH_REPORTS_INITIAL_DATA = 'FETCH_REPORTS_INITIAL_DATA';
export const UPDATE_REPORTS_FILTER = 'UPDATE_REPORTS_FILTER';
export const FETCH_REPORTS_RESIDENTS = 'FETCH_REPORTS_RESIDENTS'
export const RECEIVE_REPORTS_RESIDENTS = 'RECEIVE_REPORTS_RESIDENTS'
export const SHOW_REPORTS_LOADING = 'SHOW_REPORTS_LOADING'
export const HIDE_REPORTS_LOADING = 'HIDE_REPORTS_LOADING'
